<template>
    <v-card @click="selectDoyang(doyang)" class="mx-auto" max-width="500px">
        <v-card-title>
            {{ doyang.name }}
        </v-card-title>
        <v-card-text style="margin-top: -10px;">
            <span>Inauguración: {{ openingDate }}</span>
            <br>
            <strong>Activos: {{ doyang.student_count }}</strong>
            <ActiveStudentsDialog :doyang="doyang"></ActiveStudentsDialog>
            <br>
            <span>Click para entrar a este doyang</span>
        </v-card-text>
    </v-card>
</template>

<script>
import ActiveStudentsDialog from '../home/ActiveStudentsDialog.vue'
export default {
    name: 'DoyangCard',
    components: {
        ActiveStudentsDialog
    },
    data() { return {} },
    mounted() {
    },
    props: {
        doyang: {
            type: Object,
            required: true
        }
    },
    computed: {
        openingDate() {
            if (!this.doyang.opening_date) return 'N/A'
            const yearMonthStringDay = this.doyang.opening_date.split('-')
            let month = new Date(this.doyang.opening_date).toLocaleString('default', { month: 'short' }).toUpperCase();
            if (month == 'JAN') month = 'ENE';
            if (month == 'APR') month = 'ABR';
            if (month == 'AUG') month = 'AGO';
            if (month == 'DEC') month = 'DIC';
            return `${yearMonthStringDay[2].split('T')[0]}/${month}/${yearMonthStringDay[0]}`
        }
    },
    methods: {
        selectDoyang(doyang) {
            this.$store.commit('Auth/selectDoyang', doyang)
            this.$store.dispatch('MonthlyDuty/doyangMonthlyDuties', `?doyang_id=${doyang.id}`).then((res) => {
                this.selectedDoyangMonthlyDuties = res
            })
        }
    },
}
</script>

<style scoped>
/* Your style code here */
</style>